import { IResponseModel } from "../../IResponseModel";

export class ForgottenPasswordResponse implements IResponseModel {
    token: string;
}